import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import Document_Preview from './Document_Preview';
import Document_Renderer from './Document_Renderer';

import { useReporting } from '../../Contexts/Context_Reporter';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useAccounts } from '../../Contexts/Context_Accounts';

import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";

import Panel_Map_Center from '../InteractiveMap/Panel_Map_Center';
import UI_Card from '../ERUMAUI/UI_Card';

import { Pie, PieChart, Cell, Legend, Tooltip } from 'recharts';
import Log_Renderer from './Log_Renderer';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_LogGroup from '../ERUMAUI/UI_LogGroup';
import { UI_LogGroup_Item, UI_LogGroup_Item_Generate } from '../ERUMAUI/UI_LogGroup';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import Document_Schedule_Details from '../ScheduleManagement/Document_Schedule_Details';

import Icon_Color_Report from '../../Assets/Icons/Icon_Color_Report.png';



export default function Panel_Reporter_Center() {
    const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { Schedule_Information, Schedule_Information_History, Time_Range_Parse, Time_Parse, Status_Parse } = useScheduleManagement();
    const { Report_Type, Report_Orientation, Output_Schedules_Monthly, Output_Schedules_Timetable, Report_Loaded, Input_Room_Utilization, Output_Room_Utilization, Output_Logs, Report_Presentation, Input_Logs_Trail, Output_Logs_Trail } = useReporting();
    const { Room_Get_Address, Map_Composition, Selected_Building, Selected_Floor, Map_Time_Parameters } = useMapRenderer();
    const { Accounts_Fetch_ByID_Many_Basic, Accounts_List, Accounts_isLoading, Account_Fetch_ByID_FromState } = useAccounts();
    const Location = useLocation();

    const Item_Schedule_Monthly = ({ Data }) => {
        return (
            <div className='Document_Table_Row' Type="Schedules_Monthly">
                <td>
                    {Data.Name}
                </td>
                <td>
                    {Data.Activity.Type}
                </td>
                <td>
                    {Data.Requester.Name}
                </td>
                <td>
                    {Time_Parse(Data.Time.Start, "Shortened")}
                </td>
                <td>
                    {Time_Parse(Data.Time.Start, "Time")}
                </td>
                <td>
                    {Time_Parse(Data.Time.End, "Time")}
                </td>
                <td>
                    {Room_Get_Address(Data.RoomID, "Room")}
                </td>
                <td>
                    {Data.Approval.Initial.State === "Approved" ?
                        <UI_Icon Name="Check" />
                        :
                        Data.Approval.Initial.State === "Rejected" ?
                            <UI_Icon Name="Cross" />
                            :
                            Data.Approval.Initial.State === "Pending" ?
                                <UI_Icon Name="Pending" />
                                :
                                ""
                    }
                </td>
                <td>
                    {Data.Approval.Final.State === "Approved" ?
                        <UI_Icon Name="Check" />
                        :
                        Data.Approval.Final.State === "Rejected" ?
                            <UI_Icon Name="Cross" />
                            :
                            Data.Approval.Final.State === "Pending" ?
                                <UI_Icon Name="Pending" />
                                :
                                ""
                    }
                </td>
            </div>
        );
    }

    const Events_Schedule_Timetable = (Data) => {
        return Data.map(s => ({
            id: s._id,
            title: s.Name,
            start: s.Time.Start,
            end: s.Time.End,
            extendedProps: {
                RoomID: s.RoomID,
                Description: s.Description
            }
        }));
    };

    const Item_Schedule_Timetable = ({ Year, Week, Data }) => {
        // Calculate the starting date (Monday) of the given week
        const getWeekStartDate = (year, week) => {
            const firstDay = new Date(year, 0, 1);
            const dayOfWeek = firstDay.getDay(); // Sunday=0 ... Saturday=6
            const offset = ((week - 1) * 7) + (1 - (dayOfWeek === 0 ? 7 : dayOfWeek));
            firstDay.setDate(firstDay.getDate() + offset);
            return firstDay;
        };

        const weekStart = getWeekStartDate(Year, Week);
        const weekStartISO = weekStart.toISOString().split("T")[0];

        return (
            <div className="Schedule_Timetable">
                <UI_Divider Text={`Week ${Week} (${weekStart.toLocaleDateString()})`} />
                <FullCalendar
                    plugins={[timeGridPlugin]}
                    initialView="timeGridWeek"
                    headerToolbar={false}
                    allDaySlot={false}
                    slotMinTime="04:30:00"
                    // slotMaxTime="20:30:00"
                    slotMaxTime="17:30:00"
                    editable={false}
                    selectable={false}
                    height="auto"
                    initialDate={weekStartISO}
                    events={Events_Schedule_Timetable(Data)}
                />
            </div>
        );
    };

    const [Schedule_Timetable_Room, Schedule_Timetable_Room_Set] = useState("");

    useEffect(() => {
        if (Output_Schedules_Timetable.RoomID) {
            Schedule_Timetable_Room_Set(`Room timetable for ${Room_Get_Address(Output_Schedules_Timetable.RoomID, "Room")}`);
        } else {
            Schedule_Timetable_Room_Set("Room timetable");
        }
    }, [Output_Schedules_Timetable])

    const [Accounts, Accounts_Set] = useState({});

    useEffect(() => {
        if (Report_Type == "Reservation" && Schedule_Information) {
            const allIDs = [
                Schedule_Information?.Requester?.RequesterID,
                Schedule_Information?.Approval?.Initial?.ApproverID,
                Schedule_Information?.Approval?.Final?.ApproverID
            ];

            Accounts_Fetch_ByID_Many_Basic(allIDs).then(Accounts_Set);
        }
    }, [Schedule_Information, Report_Type]);

    const getName = (id) => Accounts[id]?.Name || "Loading...";

    const Item_AccountsList = ({ Name, Email, Role, Approval, Date_Approved }) => {
        return (
            <div className='Account_Row'>
                <p className='Account_Row_Text'>
                    {`${Name.First} ${Name.MI} ${Name.Last}`}
                </p>
                <p className='Account_Row_Text'>
                    {Email}
                </p>
                <p className='Account_Row_Text'>
                    {Role}
                </p>
                <p className='Account_Row_Text'>
                    {Date_Approved}
                </p>
                <p className='Account_Row_Text'>
                    {Approval}
                </p>
            </div>
        )
    }

    const [Room_Utilization_Graph, Room_Utilization_Graph_Set] = useState({
        Reservation: [
            { Label: "Approved", Percentage: 0.00 },
            { Label: "Rejected", Percentage: 0.00 },
            { Label: "Pending", Percentage: 100.00 }
        ],
        Reasons_Rejected: [{ Label: "", Percentage: 100.00 }],
        Reasons_Rescheduled: [{ Label: "", Percentage: 100.00 }],
        Reasons_Relocated: [{ Label: "", Percentage: 100.00 }],
        Activity_Types: [{ Label: "", Percentage: 100.00 }],
        Requester_Types: [{ Label: "", Percentage: 100.00 }],
    });

    const Graph_Clamp = (Data = [], Limit = 3) => {
        if (!Array.isArray(Data) || Data.length === 0) return [];

        const Sorted = [...Data].sort((a, b) => b.Percentage - a.Percentage);

        const Top = Sorted.slice(0, Limit);

        const Others = Sorted.slice(Limit);
        if (Others.length > 0) {
            const Others_Total = Others.reduce((acc, item) => acc + item.Percentage, 0);
            Top.push({ Label: "Others", Percentage: Math.floor(Number(Others_Total.toFixed(1))) });
        }

        return Top;
    }

    useEffect(() => {
        Room_Utilization_Graph_Set({
            Reservation: [
                { Label: "Rejected", Percentage: Math.floor((Output_Room_Utilization.Count_Reservations_Rejected / Output_Room_Utilization.Count_Reservations_Total * 100)) },
                { Label: "Approved", Percentage: Math.floor((Output_Room_Utilization.Count_Reservations_Approved / Output_Room_Utilization.Count_Reservations_Total * 100)) },
                { Label: "Pending", Percentage: Math.floor((Output_Room_Utilization.Count_Reservations_Pending / Output_Room_Utilization.Count_Reservations_Total * 100)) }
            ],
            Reasons_Rejected: Output_Room_Utilization.Commonality_Reservations_Rejected,
            Reasons_Rescheduled: Output_Room_Utilization.Commonality_Reservations_Rescheduled,
            Reasons_Relocated: Output_Room_Utilization.Commonality_Reservations_Relocated,
            Activity_Types: Graph_Clamp(Output_Room_Utilization.Commonality_Activity_Type),
            Requester_Types: Graph_Clamp(Output_Room_Utilization.Commonality_Requester_Type),
            Equipment: Output_Room_Utilization.Commonality_Equipment,
        })
    }, [Output_Room_Utilization]);

    if (Loading) {
        return null;
    }
    return (
        <>
            <div className='Report'>
                <div className='Report_View'>

                </div>
                <div className='Report_Content' Presentation={Report_Presentation}>
                    {Report_Type === "Schedule_Monthly" ?
                        <Document_Renderer
                            Type="Monthly schedule report"
                            Orientation={Report_Orientation}
                            Display={Report_Loaded}
                            Presentation={Report_Presentation}
                        >
                            
                            <UI_UpdatingStatus
                                State={Output_Schedules_Monthly?.Data?.length > 0 ? "Good" : "Bad"}
                                Bad={{
                                    Type: "Default",
                                    Icon: Icon_Color_Report,
                                    Title: "Ready to load",
                                    Text: "Please click Generate Report on the right side to view the respective report."
                                }}
                                Good={
                                    <>

                                    </>

                                }
                            />
                            {Output_Schedules_Monthly?.Data?.length > 0 ?
                                <>
                                    <UI_Divider />
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center" }}>
                                        <h3 className='General_Title'>
                                            {Time_Range_Parse(Output_Schedules_Monthly.Range_Start, Output_Schedules_Monthly.Range_End, "Month Year")}
                                            {/* {Time_Parse(Output_Schedules_Monthly.Range_Start, "Month Year") === Time_Parse(Output_Schedules_Monthly.Range_End, "Month Year") ? 
                                        Time_Range_Parse(Output_Schedules_Monthly.Range_Start, Output_Schedules_Monthly.Range_End, "Month Year")
                                        :
                                        Time_Parse(Output_Schedules_Monthly.Range_Start, "Month Year")
                                    } */}
                                        </h3>
                                        <div style={{ display: "grid", gridTemplateColumns: "auto 1fr auto 1fr auto 1fr", gap: "10px", alignItems: "center" }}>
                                            <UI_Icon Name="Check" />
                                            <p className='General_Paragraph'>
                                                Approved
                                            </p>
                                            <UI_Icon Name="Pending" />
                                            <p className='General_Paragraph'>
                                                Pending
                                            </p>
                                            <UI_Icon Name="Cross" />
                                            <p className='General_Paragraph'>
                                                Rejected
                                            </p>
                                        </div>
                                    </div>

                                    <UI_Divider />
                                </>
                                :
                                ""
                            }
                            
                            {Report_Loaded ?
                                Output_Schedules_Monthly?.Data?.flatMap((Month, Index) => ([
                                        <UI_Divider Text={Time_Parse(Month.Month, "Month Year")} />,
                                        <div className='Document_Table_Row' Type="Schedules_Monthly" Row="Head">
                                            <td>
                                                Activity
                                            </td>
                                            <td>
                                                Activity type
                                            </td>
                                            <td>
                                                Requestant
                                            </td>
                                            <td>
                                                Date
                                            </td>
                                            <td>
                                                Time start
                                            </td>
                                            <td>
                                                Time end
                                            </td>
                                            <td>
                                                Location
                                            </td>
                                            <td>
                                                OSA
                                            </td>
                                            <td>
                                                GSU
                                            </td>
                                        </div>,
                                        ...Month?.Schedules?.map((Item) => (
                                            <Item_Schedule_Monthly Data={Item} />
                                        ))


                                ]))
                                :
                                ""
                            }
                        </Document_Renderer>
                        :
                        ""
                    }
                    {Report_Type === "Schedule_Timetable" ?
                        <Document_Renderer
                            Type={Schedule_Timetable_Room}
                            Orientation={Report_Orientation}
                            Display={Report_Loaded}
                            Presentation={Report_Presentation}
                        >
                            {Output_Schedules_Timetable.Schedules.map((Week) => (
                                <Item_Schedule_Timetable
                                    key={`${Week.Year}-${Week.Week}`}
                                    Year={Week.Year}
                                    Week={Week.Week}
                                    Data={Week.Schedules}
                                />
                            ))}
                        </Document_Renderer>
                        :
                        ""
                    }
                    {Report_Type === "Floor_Utilization" ?
                        <Document_Renderer
                            Type={`Floor utilization`}
                            Orientation={Report_Orientation}
                            Display={true}
                            Subtitle={`${Map_Composition[Selected_Building]?.Name}, ${Map_Composition[Selected_Building]?.Floors[Selected_Floor]?.Name}`}
                            Presentation={Report_Presentation}
                        >
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontWeight: "bolder", marginTop: "10px", marginBottom: "10px" }}>
                                <p className='General_Paragraph'>
                                    {`${Map_Composition[Selected_Building]?.Name}, ${Map_Composition[Selected_Building]?.Floors[Selected_Floor]?.Name}`}
                                </p>
                                <p className='General_Paragraph' style={{ textAlign: "right" }}>
                                    {`${Time_Parse(Map_Time_Parameters.Date, "Date")} | ${Map_Time_Parameters.Time_Start} - ${Map_Time_Parameters.Time_End}`}
                                </p>
                            </div>
                            <div className='Floor_Utilization'>
                                <Panel_Map_Center NoControls={true} />
                            </div>
                        </Document_Renderer >
                        :
                        ""
                    }
                    {Report_Type === "Reservation" && Schedule_Information ?

                        <Document_Renderer
                            Type="Reservation Slip"
                            Orientation={Report_Orientation}
                            Display={Schedule_Information}
                            Presentation={Report_Presentation}
                        >
                            <UI_Divider Text="Activity information" />
                            <h3 className='General_Title' style={{ fontSize: "16px" }}>
                                {Schedule_Information.Name}
                            </h3>
                            <p className='General_Paragraph' style={{ marginBottom: "10px", fontSize: "12px", fontStyle: "italic" }}>
                                {Schedule_Information.Description}
                            </p>

                            <div className='Reservation_Activity'>
                                <div className="Reservation_Activity_Time">
                                    <p className='Reservation_Property'>
                                        Date:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Time_Parse(Schedule_Information.Time.Start, "Date")}
                                    </p>
                                    <p className='Reservation_Property'>
                                        Time start:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Time_Parse(Schedule_Information.Time.Start, "Time")}
                                    </p>
                                    <p className='Reservation_Property'>
                                        Time end:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Time_Parse(Schedule_Information.Time.End, "Time")}
                                    </p>
                                    <p className='Reservation_Property'>
                                        Location:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Room_Get_Address(Schedule_Information.RoomID)}
                                    </p>
                                </div>
                                <UI_ChipGroup Items={Status_Parse(Schedule_Information, "Exclude_Expiry", "Exclude_User")} />
                            </div>
                            {Schedule_Information.DelegatedStaff.length > 0 ?
                                <>
                                    <UI_Divider Text="Delegated staff" />
                                    <div className='Reservation_Properties'>
                                        <p className='Reservation_Property'>
                                            Delegated staff:
                                        </p>
                                        <p className='Reservation_Value'>
                                            <b>{Schedule_Information.DelegatedStaff.length > 0 ? Schedule_Information.DelegatedStaff.length : "None listed"}</b>
                                        </p>
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", columnGap: "5px", marginTop: "10px" }}>
                                        {Schedule_Information.DelegatedStaff.map((Item) => (
                                            <>
                                                <p className='Reservation_Property' style={{ margin: "0" }}>
                                                    {Account_Fetch_ByID_FromState(Item).Name}
                                                </p>
                                            </>
                                        ))}
                                    </div>
                                </>
                                :
                                ""
                            }
                            <UI_Divider Text="Approval information" />
                            <div className='Reservation_Table' Split="2">
                                <div className="Reservation_Properties">
                                    <p className='Reservation_Property'>
                                        Date applied:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Time_Parse(Schedule_Information.DateCreated)}
                                    </p>
                                    <p className='Reservation_Property'>
                                        OSA approved:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Schedule_Information.Approval.Initial.State == "Approved" ?
                                            <>
                                                {Time_Parse(Schedule_Information.Approval.Initial.DateApproved)}
                                            </>
                                            :
                                            Schedule_Information.Approval.Initial.State == "Pending" ?
                                                "Pending approval"
                                                :
                                                Schedule_Information.Approval.Initial.State == "Rejected" ?
                                                    "Rejected"
                                                    :
                                                    ""
                                        }
                                    </p>
                                    <p className='Reservation_Property'>
                                        GSU approved:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Schedule_Information.Approval.Final.State == "Approved" ?
                                            <>
                                                {Time_Parse(Schedule_Information.Approval.Final.DateApproved)}
                                            </>
                                            :
                                            Schedule_Information.Approval.Final.State == "Pending" ?
                                                "Pending approval"
                                                :
                                                Schedule_Information.Approval.Final.State == "Rejected" ?
                                                    "Rejected"
                                                    :
                                                    ""
                                        }
                                    </p>
                                </div>

                                <div className="Reservation_Properties">
                                    <p className='Reservation_Property'>
                                        Applicant name:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {getName(Schedule_Information.Requester.RequesterID)}
                                    </p>
                                    <p className='Reservation_Property'>
                                        OSA representative:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Schedule_Information.Approval.Initial.State == "Approved" ?
                                            <b>{getName(Schedule_Information.Approval.Initial.ApproverID)}</b>
                                            :
                                            Schedule_Information.Approval.Initial.State == "Pending" ?
                                                <b>-</b>
                                                :
                                                Schedule_Information.Approval.Initial.State == "Rejected" ?
                                                    <b>{getName(Schedule_Information.Approval.Initial.ApproverID)}</b>
                                                    :
                                                    ""
                                        }
                                    </p>
                                    <p className='Reservation_Property'>
                                        GSU representative:
                                    </p>
                                    <p className='Reservation_Value'>
                                        {Schedule_Information.Approval.Final.State == "Approved" ?
                                            <b>{getName(Schedule_Information.Approval.Final.ApproverID)}</b>
                                            :
                                            Schedule_Information.Approval.Final.State == "Pending" ?
                                                <b>-</b>
                                                :
                                                Schedule_Information.Approval.Final.State == "Rejected" ?
                                                    <b>{getName(Schedule_Information.Approval.Final.ApproverID)}</b>
                                                    :
                                                    ""
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className='Reservation_Table' Split="2">
                                {Schedule_Information.Reschedule.Date ?
                                    <div>
                                        <UI_Divider Text="Reschedule information" />
                                        <div className='Reservation_Properties'>
                                            <p className='Reservation_Property'>
                                                Reschedule reason:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{Schedule_Information.Reschedule.Reason}</b>
                                            </p>
                                            <p className='Reservation_Property'>
                                                Date rescheduled:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{Time_Parse(Schedule_Information.Reschedule.Date)}</b>
                                            </p>
                                            <p className='Reservation_Property'>
                                                Rescheduled by:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{getName(Schedule_Information.Reschedule.ReschedulerID)}</b>
                                            </p>
                                        </div>
                                    </div>

                                    :
                                    ""
                                }

                                {Schedule_Information.Relocate.Date ?
                                    <div>
                                        <UI_Divider Text="Relocation information" />
                                        <div className='Reservation_Properties'>
                                            <p className='Reservation_Property'>
                                                Relocation reason:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{Schedule_Information.Relocate.Reason}</b>
                                            </p>
                                            <p className='Reservation_Property'>
                                                Date relocated:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{Time_Parse(Schedule_Information.Relocate.Date)}</b>
                                            </p>
                                            <p className='Reservation_Property'>
                                                Relocated by:
                                            </p>
                                            <p className='Reservation_Value'>
                                                <b>{getName(Schedule_Information.Relocate.RelocatorID)}</b>
                                            </p>
                                        </div>
                                    </div>

                                    :
                                    ""
                                }
                            </div>

                            {Schedule_Information.Activity.Attendees.Names.length > 0 ?
                                <>
                                    <UI_Divider Text="Attendee information" />
                                    <div className='Reservation_Properties'>
                                        <p className='Reservation_Property'>
                                            Attendees:
                                        </p>
                                        <p className='Reservation_Value'>
                                            <b>{Schedule_Information.Activity.Attendees.Names.length > 0 ? Schedule_Information.Activity.Attendees.Names.length : "None listed"}</b>
                                        </p>
                                    </div>
                                    {Schedule_Information.Activity.Attendees.Names.length > 0 ?
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", columnGap: "5px", marginTop: "10px" }}>
                                            {Schedule_Information.Activity.Attendees.Names.map((Item) => (
                                                <>
                                                    <p className='Reservation_Property' style={{ margin: "0" }}>
                                                        {Item}
                                                    </p>
                                                </>
                                            ))}
                                        </div>
                                        :
                                        ""
                                    }
                                </>
                                :
                                ""
                            }

                            {Schedule_Information.Equipment.length > 0 ?
                                <>
                                    <UI_Divider Text="Equipment information" />
                                    <div className='Reservation_Properties'>
                                        <p className='Reservation_Property'>
                                            Equipment:
                                        </p>
                                        <p className='Reservation_Value'>
                                            <b>{Schedule_Information.Equipment.length > 0 ? Schedule_Information.Equipment.length : "None listed"}</b>
                                        </p>
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", columnGap: "5px", marginTop: "10px" }}>
                                        {Schedule_Information.Equipment.map((Item) => (
                                            <>
                                                <p className='Reservation_Property' style={{ margin: "0" }}>
                                                    {Item}
                                                </p>
                                            </>
                                        ))}
                                    </div>
                                </>
                                :
                                ""
                            }
                            <UI_Divider Text="Activity history" />
                            {Schedule_Information_History.map((Item, Index) => (
                                <UI_LogGroup_Item Item={Item} Index={Index} Render={{Pill: "Disabled"}} />
                            ))}
                            {/* <UI_LogGroup Logs={Schedule_Information_History} Paginateable={true} /> */}
                        </Document_Renderer >
                        :
                        ""
                    }
                    {Report_Type === "Accounts" && !Accounts_isLoading ?
                        <Document_Renderer
                            Orientation="Landscape"
                            Type="Accounts list"
                            Display={!Accounts_isLoading ? true : false}
                            Presentation={Report_Presentation}
                        >
                            <UI_Divider Text="Active accounts" />
                            <div className='Account_Row_Head'>
                                <p className='Account_Row_Text'>
                                    Account name
                                </p>
                                <p className='Account_Row_Text'>
                                    Email
                                </p>
                                <p className='Account_Row_Text'>
                                    Role
                                </p>
                                <p className='Account_Row_Text'>
                                    Date approved
                                </p>
                                <p className='Account_Row_Text'>
                                    State
                                </p>
                            </div>
                           
                            {Accounts_List?.map((Item) => (
                                <>
                                    {Item?.Approval?.State === "Approved" ?
                                        <Item_AccountsList
                                            Name={Item.Name}
                                            Email={Item.Email}
                                            Role={Item.Role}
                                            Approval={Item.Approval.State}
                                            Date_Approved={Time_Parse(Item.Approval.DateApproved, "Date")}
                                        />
                                        :
                                        ""
                                    }
                                </>
                            ))}
                            <UI_Divider Text="Accounts pending administrator approval" />
                            <div className='Account_Row_Head'>
                                <p className='Account_Row_Text'>
                                    Account name
                                </p>
                                <p className='Account_Row_Text'>
                                    Email
                                </p>
                                <p className='Account_Row_Text'>
                                    Role
                                </p>
                                <p className='Account_Row_Text'>
                                    Date approved
                                </p>
                                <p className='Account_Row_Text'>
                                    State
                                </p>
                            </div>
                            {Accounts_List.map((Item) => (
                                <>
                                    {Item.Approval.State === "Pending" ?
                                        <Item_AccountsList
                                            Name={Item.Name}
                                            Email={Item.Email}
                                            Role="N/A"
                                            Approval={Item.Approval.State}
                                            Date_Approved={Time_Parse(Item.Approval.DateApproved, "Date")}
                                        />
                                        :
                                        ""
                                    }
                                </>
                            ))}
                            <UI_Divider Text="Accounts rejected by administrator" />
                            <div className='Account_Row_Head'>
                                <p className='Account_Row_Text'>
                                    Account name
                                </p>
                                <p className='Account_Row_Text'>
                                    Email
                                </p>
                                <p className='Account_Row_Text'>
                                    Role
                                </p>
                                <p className='Account_Row_Text'>
                                    Date rejected
                                </p>
                                <p className='Account_Row_Text'>
                                    State
                                </p>
                            </div>
                            {Accounts_List.map((Item) => (
                                <>
                                    {Item.Approval.State === "Rejected" ?
                                        <Item_AccountsList
                                            Name={Item.Name}
                                            Email={Item.Email}
                                            Role={Item.Role}
                                            Approval={Item.Approval.State}
                                            Date_Approved={Time_Parse(Item.Approval.DateApproved, "Date")}
                                        />
                                        :
                                        ""
                                    }
                                </>
                            ))}
                            <UI_Divider Text="Accounts deactivated by administrator" />
                            <div className='Account_Row_Head'>
                                <p className='Account_Row_Text'>
                                    Account name
                                </p>
                                <p className='Account_Row_Text'>
                                    Email
                                </p>
                                <p className='Account_Row_Text'>
                                    Role
                                </p>
                                <p className='Account_Row_Text'>
                                    Date deactivated
                                </p>
                                <p className='Account_Row_Text'>
                                    State
                                </p>
                            </div>
                            {Accounts_List.map((Item) => (
                                <>
                                    {Item.Approval.State === "Deactivated" ?
                                        <Item_AccountsList
                                            Name={Item.Name}
                                            Email={Item.Email}
                                            Role={Item.Role}
                                            Approval={Item.Approval.State}
                                            Date_Approved={Time_Parse(Item.Approval.DateApproved, "Date")}
                                        />
                                        :
                                        ""
                                    }
                                </>
                            ))}
                        </Document_Renderer>
                        :
                        ""
                    }
                    {Report_Type === "User_Trail" ?
                        <Document_Renderer
                            Orientation="Landscape"
                            Type={`User trail for ${Account_Fetch_ByID_FromState(Input_Logs_Trail?.ID)?.Name}`}
                            Subtitle={`${Account_Fetch_ByID_FromState(Input_Logs_Trail?.ID)?.Email} | ${Time_Parse(Input_Logs_Trail?.Filter_Date_Start, "Shortened")} - ${Time_Parse(Input_Logs_Trail?.Filter_Date_End, "Shortened")}`}
                            Display={true}
                            Presentation={Report_Presentation}
                        >
                            <h3 className='General_Title'>
                                User trail for {Account_Fetch_ByID_FromState(Input_Logs_Trail?.ID)?.Name}
                            </h3>
                            <UI_Divider />
                            {Output_Logs_Trail.length > 0 ?
                                <div className='Log_List'>
                                    <div className='Log_List_Header' Form="Table">
                                        <p className='Log_List_Item_Actor'>
                                            User
                                        </p>
                                        <h3 className='Log_List_Item_Message'>
                                            Action
                                        </h3>
                                        <p className='Log_List_Item_Timestamp'>
                                            Timestamp
                                        </p>
                                        <p className='Log_List_Item_Action'>
                                            Action ID
                                        </p>
                                    </div>
                                </div>
                                :
                                ""
                            }

                            <UI_UpdatingStatus
                                State={Output_Logs_Trail.length > 0 && Input_Logs_Trail.ID ? "Good" : "Bad"}
                                Bad={{
                                    Type: "Default",
                                    Icon: Icon_Color_Report,
                                    Title: "Ready to load",
                                    Text: "Please click Generate Report on the right side to view their respective logs."
                                }}
                                Good={
                                    <>

                                    </>

                                }
                            />
                            {Output_Logs_Trail.map((Item, Index) => (
                                <button className='Log_List_Item' Form="Table">
                                    <p className='Log_List_Item_Actor'>
                                        {Account_Fetch_ByID_FromState(Item.Actor)?.Name}
                                    </p>
                                    <h3 className='Log_List_Item_Message'>
                                        {Item.Message}
                                    </h3>
                                    <p className='Log_List_Item_Timestamp'>
                                        {Time_Parse(Item.TimeStamp)}
                                    </p>
                                    <p className='Log_List_Item_Action'>
                                        {Item.Action}
                                    </p>
                                </button>
                            ))}
                        </Document_Renderer>
                        :
                        ""
                    }
                    {Report_Type === "Room_Utilization" ?
                        <Document_Renderer
                            Type="Room utilization"
                            Orientation="Portrait"
                            Subtitle={`${Time_Range_Parse(Input_Room_Utilization.Filter_Date_Start, Input_Room_Utilization.Filter_Date_End, "Date")}`}
                            Display={Report_Loaded}
                            Presentation={Report_Presentation}
                        >
                            <UI_Divider />
                            <p className='RoomUtil_Location'>
                                {Room_Get_Address(Output_Room_Utilization.RoomID, "Building")}, {Room_Get_Address(Output_Room_Utilization.RoomID, "Floor")}
                            </p>
                            <h3 className='RoomUtil_Title'>
                                {Room_Get_Address(Output_Room_Utilization.RoomID, "Room")}
                            </h3>
                            <UI_Divider />
                            <div className='RoomUtil_Table' Split="2">
                                <div>
                                    <div className='RoomUtil_Properties'>
                                        <p className='RoomUtil_Property'>
                                            Total reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Total}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Approved reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Approved}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Rejected reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Rejected}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Pending reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Pending}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Rescheduled reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Rescheduled}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Relocated reservations:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Output_Room_Utilization.Count_Reservations_Relocated}
                                        </p>
                                        <p className='RoomUtil_Property'>
                                            Common reserved hours:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Time_Parse(Output_Room_Utilization.Commonality_Reservations_Hours_Start, "Time")} - {Time_Parse(Output_Room_Utilization.Commonality_Reservations_Hours_End, "Time")}
                                        </p>
                                        {/* <p className='RoomUtil_Property'>
                                            Utilization:
                                        </p>
                                        <p className='RoomUtil_Value'>
                                            {Math.floor(Output_Room_Utilization.Count_Utilization_Rate)}% ({Math.floor(Output_Room_Utilization.Count_Reservations_Hours)} hours)
                                        </p> */}
                                    </div>
                                </div>
                                <div>
                                    <PieChart width={200} height={200} className='Graph'>
                                        <Pie
                                            data={Room_Utilization_Graph.Reservation}
                                            dataKey="Percentage"
                                            nameKey="Label"
                                            outerRadius={50}
                                            label
                                            isAnimationActive={false}
                                        >
                                            {Room_Utilization_Graph.Reservation.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={['#0088FE', '#00C49F', '#FFBB28', '#FF8042'][index % 4]} />
                                            ))}
                                            <Legend />
                                            <Tooltip />
                                        </Pie>
                                    </PieChart>
                                </div>
                            </div>
                            <div className='RoomUtil_Table' Split="3">
                                <div>
                                    <UI_Divider Text="Commonalities" />
                                    {Room_Utilization_Graph ?
                                        <>
                                            <p className='RoomUtil_Property'>
                                                Commonly requested equipment:
                                            </p>
                                            <p className='RoomUtil_Value'>
                                                {Room_Utilization_Graph?.Equipment?.map((Item, Index) => (
                                                    <>
                                                        {Item.Label}{Index < Room_Utilization_Graph.Equipment.length - 1 ? ", " : ""}
                                                    </>
                                                ))}
                                            </p>
                                            <UI_Divider />
                                            <p className='RoomUtil_Property'>
                                                Common reason for rejection:
                                            </p>
                                            <p className='RoomUtil_Value'>
                                                {Room_Utilization_Graph?.Reasons_Rejected[0]?.Label}
                                            </p>
                                            <UI_Divider />
                                            <p className='RoomUtil_Property'>
                                                Common reason for rescheduling:
                                            </p>
                                            <p className='RoomUtil_Value'>
                                                {Room_Utilization_Graph?.Reasons_Rescheduled[0]?.Label}
                                            </p>
                                            <UI_Divider />
                                            <p className='RoomUtil_Property'>
                                                Common reason for relocation:
                                            </p>
                                            <p className='RoomUtil_Value'>
                                                {Room_Utilization_Graph?.Reasons_Relocated[0]?.Label}
                                            </p>
                                        </>
                                        :
                                        ""
                                    }
                                </div>
                                <div>
                                    <UI_Divider Text="Common activity types" />
                                    <PieChart width={200} height={200} className='Graph'>
                                        <Pie
                                            data={Room_Utilization_Graph.Activity_Types}
                                            dataKey="Percentage"
                                            nameKey="Label"
                                            outerRadius={50}
                                            label
                                            isAnimationActive={false}
                                        >
                                            {Room_Utilization_Graph.Activity_Types.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={['#0088FE', '#00C49F', '#FFBB28', '#FF8042'][index % 4]} />
                                            ))}
                                            <Legend />
                                            <Tooltip />
                                        </Pie>
                                    </PieChart>
                                </div>
                                <div>
                                    <UI_Divider Text="Common requester types" />
                                    <PieChart width={200} height={200} className='Graph'>
                                        <Pie
                                            data={Room_Utilization_Graph.Requester_Types}
                                            dataKey="Percentage"
                                            nameKey="Label"
                                            outerRadius={50}
                                            label
                                            isAnimationActive={false}
                                        >
                                            {Room_Utilization_Graph.Requester_Types.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={['#0088FE', '#00C49F', '#FFBB28', '#FF8042'][index % 4]} />
                                            ))}
                                            <Legend />
                                            <Tooltip />
                                        </Pie>
                                    </PieChart>
                                </div>
                            </div>
                        </Document_Renderer>
                        :
                        ""
                    }
                    {Report_Type === "Logs" ?
                        <>
                            <Document_Renderer
                                Type="Activity log"
                                Orientation="Landscape"
                                Display={Report_Loaded}
                                Presentation={Report_Presentation}
                            >
                                {/* <Log_Renderer
                            Logs={Output_Logs}
                            Form="Table"
                        /> */}
                                <div className='Log_List'>
                                    <div className='Log_List_Header' Form="Table">
                                        <p className='Log_List_Item_Actor'>
                                            User
                                        </p>
                                        <h3 className='Log_List_Item_Message'>
                                            Action
                                        </h3>
                                        <p className='Log_List_Item_Timestamp'>
                                            Timestamp
                                        </p>
                                        <p className='Log_List_Item_Action'>
                                            Action ID
                                        </p>
                                    </div>
                                </div>
                                {Output_Logs.map((Item, Index) => (
                                    <button className='Log_List_Item' Form="Table">
                                        <p className='Log_List_Item_Actor'>
                                            {Account_Fetch_ByID_FromState(Item.Actor)?.Name}
                                        </p>
                                        <h3 className='Log_List_Item_Message'>
                                            {Item.Message}
                                        </h3>
                                        <p className='Log_List_Item_Timestamp'>
                                            {Time_Parse(Item.TimeStamp)}
                                        </p>
                                        <p className='Log_List_Item_Action'>
                                            {Item.Action}
                                        </p>
                                    </button>
                                ))}
                            </Document_Renderer>

                        </>
                        :
                        ""
                    }
                </div>
            </div>



        </>
    );
}
